<script>
import Layout from '../../layouts/main';
import PageHeader from '../../components/page-header';

import OrderList from './list';
import { orderService } from '../../services';
import { get_decimal } from '../../Helper/helper';
/**
 * Products-order component
 */
export default {
  components: { Layout, PageHeader, OrderList },
  data() {
    return {
        filters: null,
        orders: null,
        decimal: get_decimal()
    }
  },
  methods:{
    exportOrders() {
      console.log('hi');
      // this.loading = true;
      orderService
        .exportOrders({
          ...this.filters,
        })
        .then((response) => {
          // this.loading = false;
          this.orders = response.data.result;
          this.downloadCSV()
        })
        .catch(function (error) {
          // this.loading = false;
          console.log(error);
        });
    },
    getSelectionPrices(items){
      return parseFloat(items.length > 0 ? items.reduce(function(accu, item){
        return accu + parseFloat(item.selection_price);
      },0): 0);
    },
    getPrice(item){
      // return parseFloat((parseInt(item.quantity) * this.getSelectionPrices(item.menu_item_selections)) + (parseInt(item.quantity) * parseFloat(item.item_price || 0))).toFixed(this.decimal)
      return (parseInt(item.quantity) * parseFloat(item.item_price || 0)).toFixed(this.decimal)
    },
    downloadCSV: function(){
      let orders = '\ufeff' + 'SR,Order ID,Customer Name,Customer Number,Customer Email,Order Date/Time,'+this.$auth.getRestaurantName()+' Name,'+this.$auth.getRestaurantName()+' Number,Payment Method,Order Status,Coupon Code,Sub Total,Delivery Charge,Discount,Tax,Total Amount,Item Name,Item Price,Item Quantity\n'
      this.orders.forEach((el,ind) => {
        var line = (ind+1)+ ',' + '#' +el['id'] + ',' + el['customer']['customer_name'] + ',' 
          + el['customer']['user_id'] + ',' 
          + el['customer']['email'] + ',' + this.moment(el['created_at']).format('DD-MM-YYYY hh:mm A') + ',' 
          + (el['restaurant']?el['restaurant']['name']:'-') +',' 
          + (el['restaurant']?el['restaurant']['phone']:'-') +',' 
          + el['payment_method_name'] +',' 
          + el['order_status'] +',' 
          + (el['reddemed_coupon_order']?el['reddemed_coupon_order']['coupon']['coupon_code']:'--') +',' 
          + el['sub_total'] +',' 
          + el['delivery_fee'] +',' 
          + (el['reddemed_coupon_order']?parseFloat(el['reddemed_coupon_order']['original_price'] - el['reddemed_coupon_order']['discount_price']):'--') +',' 
          + (el['service_fee']?el['service_fee']:'--') +',' 
          + el['total_amount'] +',';
          // + (el['notes']?el['notes']:'--' )+',';
        var i = 0;
        do{
          // get Item name
          let product_name = el['order_item'][0]['sub_products'][0]['product']['item_name']??'';
          let selling_qty = el['order_item'][0]['selling_qty']??'';
          let size  = el['order_item'][0]['sub_products'][0]['size_attribute']['size']['att_name']??'';
          let material = el['order_item'][0]['sub_products'][0]['size_attribute']['material']['att_name']??'';
          let fullItemName = product_name +  ' ' + selling_qty + ' x ' + size + ` ( ${material} )`;
          // get Item name

          line += fullItemName +',' 
                +(el['order_item'] && el['order_item'][i] && this.getPrice(el['order_item'][i]) || '0') +',' 
                + (el['order_item'] && el['order_item'][i] && el['order_item'][i]['quantity'] || '') +','
                +'\n';
              
          i++;
          orders += line;
          line = ',,,,,,,,,,,,,,,,';
        } while(el['order_item'].length > i);
      })
      var blob = new Blob([ orders ], { "type" : "csv/plain" });
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'orders-' + new Date().getTime() +'.csv'
      link.click()
    },
    updateFilters(filters){
      this.filters = filters;
    }
  }
}
</script>

<template>
 <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-copy-alt"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Orders') }}</h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link :to="{name: 'order-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Order') }}
            </router-link>
            <button
              @click="exportOrders()"
              class="btn btn-primary btn-rounded export-btn"
            >{{trans.get('__JSON__.Export To CSV')}}</button>
            <button
              @click="exportOrders()"
              class="btn btn-primary btn-rounded m-export-btn"
            ><i class="bx bx-archive-in"></i></button>
          </div>
        </div>
      </div>
    </div>
    <OrderList @filterChange="updateFilters" />
  </Layout>
</template>
